
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 131 65"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M127.1 58.69V32.41h-6.2V57.3a1.32 1.32 0 01-1.4 1.39H15.27a1.33 1.33 0 01-1.41-1.41l-.11-3.09H7.67v4.5s0 6 6.19 6h107s6.2.25 6.2-6h.04zm-6-48h6V5.92c0-1.16-.29-5.92-6.2-5.92h-107S7.71 0 7.71 5.92v4.77h6.08l.11-3.57a1.41 1.41 0 011.37-1.43h104.24a1.35 1.35 0 011.41 1.4l.15 3.6h.03z"}}),_c('path',{attrs:{"d":"M109.94 36.98v-8.67c0-7.5-3.77-11.73-11.22-11.73-7.45 0-11.22 4.23-11.22 11.73v8.67c0 7.49 3.77 11.71 11.22 11.71 7.45 0 11.22-4.23 11.22-11.73v.02zm-6.89-.29c0 3.67-1.28 5.61-4.34 5.61-3.06 0-4.33-1.91-4.33-5.61v-8.13c0-3.67 1.27-5.61 4.33-5.61s4.34 1.94 4.34 5.61v8.13zm-54.31.29v-8.67c0-7.5-3.78-11.73-11.22-11.73-7.44 0-11.21 4.23-11.21 11.73v8.67c0 7.49 3.77 11.71 11.21 11.71 7.44 0 11.22-4.23 11.22-11.73v.02zm-6.88-.29c0 3.67-1.27 5.61-4.34 5.61s-4.33-1.91-4.33-5.61v-8.13c0-3.67 1.27-5.61 4.33-5.61s4.34 1.94 4.34 5.61v8.13zm-20.97 11.5v-6.37h-6.73V17.09H7.78l-7.23 2.7v6.63l6.73-1.94v17.34H0v6.37h20.89m109.56-26.71a6.65 6.65 0 10-13.3 0 6.65 6.65 0 0013.3 0zm-4.21 0a2.44 2.44 0 11-2.44-2.45 2.45 2.45 0 012.44 2.45zm-46.9 15.5v-8.67c0-7.5-3.77-11.73-11.22-11.73-7.45 0-11.22 4.23-11.22 11.73v8.67c0 7.49 3.78 11.71 11.22 11.71 7.44 0 11.22-4.23 11.22-11.73v.02zm-6.88-.29c0 3.67-1.27 5.61-4.34 5.61s-4.33-1.91-4.33-5.61v-8.13c0-3.67 1.27-5.61 4.33-5.61s4.34 1.94 4.34 5.61v8.13z"}})])
          )
        }
      }
    